// extracted by mini-css-extract-plugin
module.exports = {"pages":"PagesDropdown_pages__29Plp"};